import { Pipe, PipeTransform } from '@angular/core';
import { ceLabelFormatterUtil } from '../utils/ce-label-formatter.utils';

/**
 * Angular pipe to format API event values into human-readable labels
 * Converts camelCase/PascalCase API enum values to user-friendly display text
 */
@Pipe({
  name: 'sgCorporateEventLabelFormatter',
  standalone: false,
})
export class SgCorporateEventLabelFormatterPipe implements PipeTransform {
  transform(eventValue: string): string {
    return ceLabelFormatterUtil(eventValue);
  }
}
